import { ConsentConfig } from "@flow/common/types";

/**
 * Separate ConsentConfigs out based on whether they are implicit or explicit
 */
export function partitionConsentConfigs(
  consentConfigs: ConsentConfig[]
): [implicit: ConsentConfig[], explicit: ConsentConfig[]] {
  return consentConfigs.reduce(
    (result: [ConsentConfig[], ConsentConfig[]], config) => {
      result[config.input.type === "implicit" ? 0 : 1].push(config);
      return result;
    },
    [[], []]
  );
}
